import { FunctionFactory } from 'survey-core';

export const dateValidationFunctions = () => {
  FunctionFactory.Instance.register('validateDateOfBirth', (params) => validateDateOfBirth(params));
}

function validateDateOfBirth(params: any) {
  if (params.length < 1) {
    return false;
  }

  let dateToValidate = params[0];
  if (typeof dateToValidate == 'string') {
    dateToValidate = Date.parse(dateToValidate);
  }

  // If date is invalid
  if (isNaN(dateToValidate)) {
    return false;
  }

  const dateIsBeforeNow = dateToValidate <= new Date(); // NRDS errors when dob > now
  const dateIsNotTooOld = dateToValidate >= new Date('1900-01-01T00:00:00'); // NRDS errors when year of dob < 1700

  return dateIsBeforeNow && dateIsNotTooOld;
}
